export const INVENTORY_SEARCHABLE_FIELDS = {
  PRODUCT_TYPE: 'productTypeName',
  BRAND: 'brand',
  SUB_TYPE: 'subType',
  CLASSIFICATION: 'classification',
  GENERALS: 'generals',
  EFFECTS: 'effects',
  FLAVORS: 'flavors',
  PRODUCT_ID: 'productId',
  PRICE: 'price',
  THC_PERCENT: 'totalThcPercent',
  CATEGORY_PRIORITY: 'categoryPriority',
  PRODUCT_NAME: 'productName',
  MENU_PRODUCT_NAME: 'menuProductName',
  COLLECTIONS: 'collections',
}


// WEBPACK FOOTER //
// ./src/const/inventorySearchableFields.js